import React, { CSSProperties, ReactNode } from 'react';
import cx from 'classnames';
import styles from './Badge.less';

interface BasicBadgeProps {
  bgColor?: string;
  className?: string;
  fontColor?: string;
}

export const Badge: React.FC<BasicBadgeProps> = ({
  bgColor,
  className,
  fontColor,
  children,
}) => {
  const dynamicStyles: CSSProperties = {};
  if (bgColor) {
    dynamicStyles.backgroundColor = bgColor;
  }
  if (fontColor) {
    dynamicStyles.color = fontColor;
  }

  return (
    <span className={cx(styles.badge, className)} style={dynamicStyles}>
      {children}
    </span>
  );
};

interface IconBadgeProps extends BasicBadgeProps {
  icon: ReactNode;
  iconHeight?: number;
  iconWidth?: number;
}

export const IconBadge: React.FC<IconBadgeProps> = ({
  bgColor = '',
  children,
  className = '',
  fontColor = '',
  icon,
  // iconHeight = 16,
  // iconWidth = 16,
}) => (
  <Badge bgColor={bgColor} className={className} fontColor={fontColor}>
    <div className={styles.flex}>
      <span className={styles.badgeIcon}>{icon}</span>
      {children && <span className={styles.badgeIconLabel}>{children}</span>}
    </div>
  </Badge>
);
